import React from "react";
import LwsLogoSvg from "./img/lws-logo.svg";
import { Link } from "react-router-dom";

const Header = () => {
  
  return (
    <header id="header">
      <div className="container">
        <img src={LwsLogoSvg} alt="logo" className="logo" />
        <div className="flex items-center">
          <Link to="#" className="text-white min-w-[50px] font-medium">
            Home
          </Link>
          <button className="log-btn btn">Login</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
